/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const BillingStateResponse = zod
	.object({
		allowed_topup_amounts_usd: zod.array(zod.string()).describe('Allowed top-up amounts'),
		balance: zod
			.object({
				balance_usd: zod.string().nullable().describe('Current balance in USD')
			})
			.describe('Prepaid balance state'),
		contract: zod
			.object({
				block_reason: zod.string().nullable().describe('Reason the contract is blocked'),
				entitled: zod.boolean().describe('Whether the contract is entitled for usage'),
				id: zod.string().describe('Contract ID'),
				package_key: zod.string().describe('Package key'),
				package_name: zod.string().describe('Package display name'),
				started_at: zod.iso.datetime({ offset: true }).describe('Contract start timestamp'),
				status: zod.enum(['pending', 'active', 'expired'])
			})
			.describe('Active contract state'),
		payment_method: zod
			.object({
				has_payment_method: zod.boolean().describe('Whether a default payment method is configured')
			})
			.describe('Payment method state'),
		settings: zod
			.object({
				auto_recharge_effective: zod
					.boolean()
					.describe('Whether auto-recharge is active on the billing provider'),
				auto_recharge_enabled: zod.boolean().describe('Auto-recharge enabled'),
				auto_recharge_target_usd: zod.string().nullable().describe('Auto-recharge target'),
				auto_recharge_threshold_usd: zod.string().nullable().describe('Auto-recharge threshold'),
				hard_limit_usd: zod.string().nullable().describe('Hard spending limit'),
				soft_limit_usd: zod.string().nullable().describe('Soft spending limit')
			})
			.describe('Billing settings')
	})
	.describe('Full billing state');

export type BillingStateResponse = zod.input<typeof BillingStateResponse>;
export type BillingStateResponseOutput = zod.output<typeof BillingStateResponse>;
